/*
export const someMutation = (state) => {
}
*/
import Vue from 'vue';
import utils from '../others/utils.js';
import { Notify } from 'quasar';
import { index } from '../others/search.js';

const emptyUser =
  {
    email: '',
    screenname: '',
    password: '',
    access_token: '',
    db: '',
    roles: [],
    telcode: null,
  };
const filterUpdates = (updates) => {
  const result = {};
  if (updates.db) result.db = updates.db;
  if (updates.email) result.email = updates.email;
  if (updates.screenname) result.screenname = updates.screenname;
  if (updates.roles) result.roles = updates.roles;
  if (updates.password) result.password = updates.password;
  if (updates.access_token) result.access_token = updates.access_token;
  if (typeof updates.telcode !== 'undefined') result.telcode = updates.telcode;
  return result;
};

export default {
  setActive(state, value) {
    console.log('STORE setActive', value);
    state.active = value;
  },
  setRefreshing(state, value) {
    console.log('STORE setRefreshing', value);
    state.refreshing = value;
  },
  setNext(state, value) {
    console.log('STORE setNext', value);
    state.next = value;
  },
  setPrev(state, value) {
    console.log('STORE setPrev', value);
    state.prev = value;
  },
  setTotal(state, value) {
    console.log('STORE setTotal', value);
    state.total = value;
  },
  setPageHeight(state, value) {
    console.log('STORE setPageHeight', value);
    state.pageHeight = value;
  },
  setRightVisible(state, value) {
    console.log('STORE setRightVisible', value);
    state.rightVisible = value;
  },
  setSearchQuery(state, query) {
    console.log('setSearchQuery', query);
    state.searchQuery = query;
  },
  setResults(state, data) {
    console.log('STORE setResults', data);
    state.searchResults.results = data.results;
    state.searchResults.term = data.term;
    state.searchResults.where = data.where;
  },
  setUnits(state, docs) {
    console.log('STORE setUnits');
    state.units = {};
    state.cases = {};
    state.requests = [];
    state.settings = {};
    docs.forEach((item) => {
      if (item._id === 'settings') {
        state.settings = Object.assign({}, item);
      } else if (item._id.indexOf('req:') === 0) {
        const date = (new Date(+item._id.substr(4))).toLocaleString('ru');
        state.requests.push(Object.assign({ date }, item));
      } else if (item._id[0] === 'c') {
        Vue.set(state.cases, item._id, Object.assign({}, utils.formatCase(item, state)));
        index(item); // for QuickSearch
      } else {
        Vue.set(state.units, item._id, Object.assign({}, item));
        index(item); // for QuickSearch
      }
    });
  },
  setOffMedias(state, docs) {
    console.log('setOffMedias', docs);
    state.offMedias = {};
    docs.forEach((item) => {
      Vue.set(state.offMedias, item._id, Object.assign({}, item));
    });
  },
  setParents(state, rows) {
    state.parents = {};// rows.length ? {} : null;
    rows.forEach((row) => {
      const children = row.value.split(';');
      const parent = {};
      children.forEach((child) => {
        parent[child] = 0;
      });
      Vue.set(state.parents, row.key, parent);
    });
  },
  endInitializing(state) {
    state.initializing = false;
  },
  setSyncing(state, value) {
    state.syncing = value;
  },
  setSyncer(state, value) {
    state.syncer = value;
  },
  setBuffer(state, value) {
    state.buffer = value;
  },
  modifyUser(state, updates) {
    console.log('STORE modifyUser', updates);
    if (updates) {
      Object.assign(state.user, filterUpdates(updates));
    } else {
      Object.assign(state.user, emptyUser);
    }
    localStorage.setItem('user', JSON.stringify(state.user));
    utils.setCookie('mtech_token', state.user.access_token, null, null, null, '/wikimedia');
  },
  /**
   * handleChanges (state, doc)
   */
  handleChanges(state, doc) {
    console.log('MUTATION handleChanges', doc);
    // exclude design docs
    if (doc._id[0] !== '_') {
      if (doc._id === 'settings') {
        state.settings = Object.assign({}, doc);
      } else if (doc._id.indexOf('req:') === 0) {
        if (doc._deleted) {
          const i = state.requests.findIndex(item => item._id === doc._id);
          if (i > -1) {
            state.requests.splice(i, 1);
          }
        } else {
          const req = state.requests.find(item => item._id === doc._id);
          if (req) {
            Object.assign(req, doc);
          } else {
            const date = (new Date(+doc._id.substr(4))).toLocaleString('ru');
            state.requests.push(Object.assign({ date }, doc));
          }
        }
      } else if (doc._id[0] === 'x') {
        if (doc._deleted) {
          Vue.delete(state.offMedias, doc._id);
        } else {
          Vue.set(state.offMedias, doc._id, Object.assign({}, doc));
        }
      } else {
        const oldParent = state.units[doc._id] ? state.units[doc._id].parent_id : null;
        if (doc._deleted) {
          if (doc._id[0] === 'c') {
            Vue.delete(state.cases, doc._id); // case
          } else {
            Vue.delete(state.units, doc._id); // others
          }
          if (oldParent) {
            Vue.delete(state.parents[oldParent], doc._id); // delete child
            if (utils.o2a(state.parents[oldParent]).length === 0) {
              Vue.delete(state.parents, oldParent); // if no child delete parent
            }
          }
        } else {
          index(doc); // for QuickSearch
          if (doc._id[0] === 'c') { // case
            Vue.set(state.cases, doc._id, Object.assign({}, utils.formatCase(doc, state)));
          } else {
            Vue.set(state.units, doc._id, Object.assign({}, doc)); // others
          }
          const newParent = doc.parent_id;
          if (newParent !== oldParent) { // parent changed
            if (state.parents[newParent]) {
              Vue.set(state.parents[newParent], doc._id, 0); // add child to new parent
            } else {
              const parent = {};
              parent[doc._id] = 0;
              Vue.set(state.parents, newParent, parent); // create new parent if don't exist
            }
            if (oldParent) {
              Vue.delete(state.parents[oldParent], doc._id); // delete old parent child
              if (utils.o2a(state.parents[oldParent]).length === 0) {
                Vue.delete(state.parents, oldParent); // if no child delete parent
              }
            }
          }
        }
      }
    }
  },
  /**
   * pushError (state, error)
   * Display Toast
   */
  pushError(state, error) {
    console.log('STORE pushError', error);
    state.errors.push(error);
    let message = typeof (error.error) === 'string' ? error.error : typeof (error.name) === 'string' ? error.name : null;
    if (message === 'forbidden') {
      message = 'Запрещено!';
    }
    const type = error.type || 'negative';
    const detail = error.message;
    if (typeof (error.callback) === 'function') {
      Notify.create({
        type,
        message,
        detail,
        timeout: 0,
        position: 'top',
        actions: [
          {
            label: 'Ok',
            handler: error.callback,
          },
        ],
      });
    } else {
      Notify.create({
        type, message, detail, timeout: 1000, position: 'top',
      });
    }
  },
  SOCKET_ONOPEN(state, event) {
    Vue.prototype.$socket = event.currentTarget;
    console.log('Connected');
    state.socket.isConnected = true;
  },
  SOCKET_ONCLOSE(state) {
    console.log('Disconnected');
    state.socket.isConnected = false;
  },
  SOCKET_ONERROR(state, event) {
    console.error(state, event);
  },
  // default handler called for all methods
  SOCKET_ONMESSAGE(state, message) {
    console.log('socket.message', message);
    state.socket.message = message;
  },
  // mutations for reconnect methods
  SOCKET_RECONNECT(state, count) {
    console.info(state, count);
  },
  SOCKET_RECONNECT_ERROR(state) {
    state.socket.reconnectError = true;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js